<template>
  <div>
    <div
      class="ui active inverted dimmer"
      v-if="!isLoaded">
      <div class="ui text loader">Loading</div>
    </div>
    <div
      v-if="isLoaded">
      <hero-image/>
      <feature-right :imageLink="activeLandingPageContent.featureOneImageLink">
        <div slot="title">{{ activeLandingPageContent.featureOneHeader }}</div>
        <p slot="body">{{ activeLandingPageContent.featureOneBody }}</p>
      </feature-right>
      <feature-left :imageLink="activeLandingPageContent.featureTwoImageLink">
        <div slot="title">{{ activeLandingPageContent.featureTwoHeader }}</div>
        <p slot="body">{{ activeLandingPageContent.featureTwoBody }}</p>
      </feature-left>
      <feature-right :imageLink="activeLandingPageContent.featureThreeImageLink">
        <div slot="title">{{ activeLandingPageContent.featureThreeHeader }}</div>
        <p slot="body">{{ activeLandingPageContent.featureThreeBody }}</p>
      </feature-right>
      <footer-call-to-action/>
    </div>
  </div>
</template>

<script>
  import HeroImage from '../components/HeroImage'
  import FeatureLeft from '../components/FeatureLeft'
  import FeatureRight from '../components/FeatureRight'
  import FooterCallToAction from '../components/FooterCallToAction'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'Home',
    components: {
      HeroImage,
      FeatureLeft,
      FeatureRight,
      FooterCallToAction
    },
    data () {
      return {
        isLoaded: false
      }
    },
    computed: {
      ...mapState(['activeLandingPage']),
    },
    methods: {
      ...mapActions(['updateActiveLandingPage']),
    },
    created () {
      switch (this.$route.params.variant.toLowerCase()) {
        case 'symptom-tracker':
          this.updateActiveLandingPage({ activeLandingPage: 'symptomTracker'}).then(()=> {
            this.isLoaded = true;
          })
          break
        case 'crowdsource-community':
          this.updateActiveLandingPage({ activeLandingPage: 'crowdsourceAltruistic'}).then(()=> {
            this.isLoaded = true;
          })
          break
        case 'crowdsource-answers':
          this.updateActiveLandingPage({ activeLandingPage: 'crowdsourceSelfish'}).then(()=> {
            this.isLoaded = true;
          })
          break
        default:
          if (typeof (this.$route.query.referral) !== 'undefined') {
            this.$router.push({ path: '/crowdsource-community', query: { referral: this.$route.query.referral } })
          } else {
            this.$router.push({ path: '/crowdsource-community' })
          }
          this.updateActiveLandingPage({ activeLandingPage: 'crowdsourceAltruistic'}).then(()=> {
            this.isLoaded = true;
          })
          break
      }
    },
  }
</script>

<style scoped>

</style>
